module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label-tag', {
    attrs: {
      "tagArray": ['學習點', '任務'],
      "currentTag": 1
    },
    on: {
      "getSence": _vm.getSence
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "px-5 table-responsive",
    staticStyle: {
      "overflow": "auto",
      "min-height": "50vh",
      "font-size": "1.25rem"
    }
  }, [_c('table', {
    staticClass: "table table-borderless table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('username')) + "\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('name')))]), _vm._v(" "), _c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            任務名稱\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            最高任務評價\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "order-btn pointer"
  }, [_vm._v("\n            完成時間\n            "), _c('font-awesome-icon', {
    staticClass: "form_icon",
    attrs: {
      "icon": ['fas', 'sort-down']
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n            任務全紀錄\n          ")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-top": "1px #cccccc solid",
      "text-align": "left"
    }
  }, _vm._l((_vm.record.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n            " + _vm._s(item.userName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.realName) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.sceneName ? item.sceneName : '-') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.grade ? item.grade : '-') + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(item.spendTime) + "\n          ")]), _vm._v(" "), _c('td', [(item.spendTime === '0:00:00') ? _c('a', {
      staticClass: "disabled",
      attrs: {
        "href": "javascript:void(0);"
      }
    }, [_vm._v("\n              個人任務歷程\n            ")]) : _c('a', {
      attrs: {
        "href": "javascript:void(0);"
      },
      on: {
        "click": function($event) {
          return _vm.goInfo(item.userId)
        }
      }
    }, [_vm._v("\n              個人任務歷程\n            ")])])])
  }), 0)])]), _vm._v(" "), _c('Pagination', {
    staticClass: "mt-5",
    attrs: {
      "current": _vm.record.pageIndex,
      "total": _vm.record.pageCount
    },
    on: {
      "page": _vm.updatePage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ccc77518!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/tw/record/RecordMission.vue
// module id = 808
// module chunks = 3